import { render } from "./App.vue?vue&type=template&id=031aaf10&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./assets/scss/theme.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=031aaf10&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__